export default "__VITE_ASSET__b401de5f__"